function pickIcon(title = "") {
  if (title.startsWith("Total ")) return "💰";
  if (title.startsWith("Average ")) return "📐";
  if (title.startsWith("Top ")) return "🏆";
  if (title.endsWith("Trend")) return "📈";
  if (title === "Total Records") return "🗂️";
  return "📌";
}

export default function KpiCard({ title, value, subtext }) {

  const isDown = typeof value === "string" && value.startsWith("-");
  const isUp = typeof value === "string" && value.startsWith("+");

  return (
    <div className="relative bg-gray-900/80 rounded-2xl p-5 shadow-lg border border-gray-800 min-h-[100px] flex flex-col justify-between overflow-hidden group hover:border-gray-700 transition-colors">

      {/* subtle accent glow */}
      <div className="absolute -top-8 -right-8 w-24 h-24 bg-blue-500/10 rounded-full blur-2xl group-hover:bg-blue-500/20 transition-colors" />

      <div className="flex items-center justify-between relative">
        <h3 className="text-gray-400 text-xs font-medium uppercase tracking-wide leading-snug whitespace-normal break-words pr-2">
          {title}
        </h3>
        <span className="text-lg shrink-0">{pickIcon(title)}</span>
      </div>

      <div className="relative">
        <p
          className={`text-2xl font-bold mt-2 ${
            isUp ? "text-emerald-400" : isDown ? "text-red-400" : "text-white"
          }`}
        >
          {value}
        </p>

        {subtext && (
          <p className="text-xs text-gray-500 mt-1">{subtext}</p>
        )}
      </div>

    </div>
  );
}
